import { t } from "@impero-com/common/utils/i18n";
import { notifyRequestError } from "@impero-com/common/utils/query_client";
import { useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";

import { usePutUsersUserIdEmail } from "api/generated/users/users";

import { USER_WITH_DETAILS_QUERY_KEY } from "./useUserWithDetailsQuery";

const EMAIL_CONFLICT_STATUS = 409;

export function useUpdateUserEmailMutation() {
    const client = useQueryClient();

    return usePutUsersUserIdEmail({
        mutation: {
            onSuccess: (_response, { userId }) => {
                client.invalidateQueries({
                    queryKey: [USER_WITH_DETAILS_QUERY_KEY, userId],
                });
            },
            onError: (error) => {
                if (error.response?.status === EMAIL_CONFLICT_STATUS) {
                    notification.error({
                        message: t("User_Change_Email_Conflict_Message"),
                        description: t(
                            "User_Change_Email_Conflict_Description"
                        ),
                    });
                    return;
                }
                notifyRequestError(error);
            },
        },
    });
}
